import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IEvento,
  ICreateEvento,
  IListado,
  IQueryParam,
  IUpdateEvento,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class EventosService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<IEvento>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/eventos`, { params });
  }

  public crear(dato: ICreateEvento): Observable<IEvento> {
    return this.http.post(`${api}/eventos`, dato);
  }

  public listarPorId(id: string): Observable<IEvento> {
    return this.http.get(`${api}/eventos/${id}`);
  }

  public editar(id: string, dato: IUpdateEvento): Observable<IEvento> {
    return this.http.put(`${api}/eventos/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/eventos/${id}`);
  }
}
